// Keep the latest successful summary through clarifications; never persist it.
export function nextSummary(previous, result) {
  if(result.agent_context)return {kind:'agent_context',agent_context:result.agent_context};
  if(previous?.kind==='agent_context')return previous;
  if(result.kind==='detail'&&result.patient?.patient_id)return {kind:'patient_context',patient_id:String(result.patient.patient_id)};
  if(result.migration_patient_id)return {kind:'patient_context',patient_id:String(result.migration_patient_id)};
  if(result.kind==='multi_agent')return result.query_token?result:previous;
  if(result.kind==='infection_workbench'||result.kind==='patient_workbench')return result.query_token?result:previous;
  if (['summary','infection','order','dar','home_summary','tot','general'].includes(result.kind)) return result;
  if (result.kind === 'home_records') return {...result,kind:'home_summary'};
  if (result.kind === 'infection_records') return {...result,kind:'infection'};
  if (result.kind === 'order_records') return {...result,kind:'order'};
  if (result.kind === 'patients' && result.pageQuery?.summary_query) return {applied_query:result.pageQuery.summary_query};
  if (['patient_infections','infection_choices','patients','detail','manager','patient_status','transfer_date','training_date','comparison','trend'].includes(result.kind)) return null;
  return previous;
}
